import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Alert } from "@mui/material";
import { setSelectedPartyId, setSelectedProductId } from "store/slice/PharmaSlice";
import { clearErrMsg,setEditOrderStory, clearInfoMsg } from "store/slice/AppSlice";
import PharmaorderPageEditProduct from "components/pharmaorder/page/PharmaorderPageEditProduct";
import SubmitOrderConfirmation from "story/SubmitOrderConfirmation";
import ShowProformaInvoice from "components/product/components/price-calculation/ShowProformaInvoice";
import OrderReview from "./OrderReview";
import OrderReviewMD from "./OrderReviewMD";
import { userprofileInfo } from 'store/slice/HeaderSlice';
import OrderReviewAccounts from "./OrderReviewAccounts";


export default function EditOrderStory() {
  const dispatch = useDispatch();
  const { editOrderStory } = useSelector((state) => state.appslice);
  const { partyObj } = useSelector((state) => state.pharmaslice.partyDashboard);
  const { errMsg, infoMsg } = useSelector((state) => state.appslice);
  const {pharmaorderObj} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard);
  const [openInfo, setOpenInfo] = useState(false);
  const {userprofileInfo} = useSelector((state) => state.headerslice);

  // useEffect(() => {
  //   dispatch(setEditOrderStory({
  //               title: "Order # "+pharmaorderObj.id+" Submitted",
  //               description: "Add products to the order for the selected party",
  //               currentState: "ORDER_SUBMITTED",
  //             }));
  // },[pharmaorderObj]);
      
  useEffect(() => {
    dispatch(setSelectedPartyId(pharmaorderObj.partyid)); // Reset selected product ID when the story starts
    dispatch(setEditOrderStory({ // Initialize the add order story state
      title: "Manage Product(s)",
      description: "Manage Product(s)",
      currentState: "ORDER_DASHBOARD",
    }));
  }, []);

  useEffect(() => {

  }, [editOrderStory]);

  useEffect(() => {
    if (infoMsg) {
      setOpenInfo(true);
      const timer = setTimeout(() => {
        setOpenInfo(false);
        dispatch(clearInfoMsg()); // Reset infoMsg in store
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [infoMsg, dispatch]);

  const getComponent = () => {
    if (editOrderStory.currentState === "ORDER_REVIEW") {
      if (userprofileInfo.rolename === "PHARMA_OMS_MD") {
        return <OrderReviewMD />;
      } 
      else if (userprofileInfo.rolename === "PHARMA_OMS_ACCOUNTS") {
        return <OrderReviewAccounts />;
      } 
      else {
        return <OrderReview />;
      }
        return <OrderReview />;
    } else if (editOrderStory.currentState === "ORDER_DASHBOARD") {
      return <PharmaorderPageEditProduct />;
    }else {
      return <Grid >Component not FOUND</Grid>;
    }

  };
  const handleCloseError = () => {
    dispatch(clearErrMsg(""));
  };
  const handleCloseInfo = () => {
    setOpenInfo(false);
    dispatch(clearErrMsg("infoMsg")); // Reset infoMsg in store
  };
  return (
    <>
      {/* Error Dialog */}
      <Dialog open={!!errMsg} onClose={handleCloseError} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ bgcolor: 'error.main', color: 'white', display: 'flex', alignItems: 'center' }}>
          Error
        </DialogTitle>
        <DialogContent >
          <Typography variant="h6" sx={{ paddingTop: 2 }}>
            {errMsg}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" onClick={handleCloseError}>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={!!infoMsg && openInfo}
        autoHideDuration={5000}
        onClose={handleCloseInfo}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseInfo}
          severity="success"
          sx={{ width: '100%' }}
          variant="filled"
        >
          {infoMsg}
        </Alert>
      </Snackbar>

      <Grid container direction="column" sx={{ width: '100%', backgroundColor: 'secondary.lighter', }}>
        {/* <Grid lg={12} xs={12} item sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h4" sx={{ color: 'primary.main', fontWeight: 'bold', borderBottom: '2px solid grey' }}>
            {editOrderStory.title}
          </Typography>
        </Grid> */}
        {getComponent()}
      </Grid>
    </>

  );
}